import { pipe, map, prop } from 'ramda'
import { mergeSpec } from '@/utils'
import useFinancialFiles from '@/hooks/use-financial-files'
import useRole from '@/hooks/use-role'
import { MobileDocumentsView as DocumentComponent } from '@/features/Application/elements'

const MobileDocumentsView = ({ application = {}, isLocked, isLoading }) => {
  const userRole = useRole()
  const userId = application?.user_id
  const userFiles = userId ? application?.users?.[userId]?.files?.user_secure_files : undefined
  const secureFiles = useFinancialFiles(userFiles, userRole)

  const formattedFiles = pipe(
    map(
      mergeSpec({
        type: prop('document_type')
      })
    )
  )(secureFiles)

  return formattedFiles?.map(file => (
    <DocumentComponent
      key={file?.id}
      data={file}
      isLocked={isLocked}
      application={application}
      isLoading={isLoading}
      tag={file?.tag}
    />
  ))
}

export default MobileDocumentsView
